import { Component, OnInit } from '@angular/core';
import { LandingPageService } from '../../../core/services/landing-page.service';
import { App } from '../../../core/interfaces/app';

@Component({
  selector: 'dum-apps',
  templateUrl: './apps.component.html',
  styleUrls: ['./apps.component.scss'],
})
export class AppsComponent implements OnInit {
  apps: App[];

  constructor(private landingPageService: LandingPageService) {}

  ngOnInit(): void {
    this.apps = this.landingPageService.getAvailableApps();
  }
}
